import styled, { css } from "styled-components";
import { ButtonSize } from "./interface";

export enum ButtonIconPosition {
  LEFT,
  RIGHT,
}

export interface ButtonIconProps {
  buttonSize: ButtonSize;
  iconPosition: ButtonIconPosition;
}

export const iconMarginByButtonSize: { [key in ButtonSize]: number } = {
  [ButtonSize.LARGE_MOBILE]: 4,
  [ButtonSize.LARGE]: 4,
  [ButtonSize.MEDIUM]: 4,
  [ButtonSize.SMALL]: 4,
  [ButtonSize.XSMALL]: 2,
  [ButtonSize.XSMALL]: 2,
  [ButtonSize.DROP_DOWN]: 2,
};

export const buttonIconSizeByButtonSize: { [key in ButtonSize]: number } = {
  [ButtonSize.LARGE]: 24,
  [ButtonSize.MEDIUM]: 18,
  [ButtonSize.SMALL]: 18,
  [ButtonSize.XSMALL]: 12,
  [ButtonSize.LARGE_MOBILE]: 24,
  [ButtonSize.DROP_DOWN]: 18,
};

export const getButtonIconSize = (buttonSize: ButtonSize) => {
  const size = buttonIconSizeByButtonSize[buttonSize];
  return css`
    width: ${size}px;
    height: ${size}px;
  `;
};

export const IconButtonLayout = styled.div<ButtonIconProps>`
  flex: none;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) => getButtonIconSize(props.buttonSize)};
  ${(props) =>
    props.iconPosition === ButtonIconPosition.LEFT
      ? `margin-right: ${iconMarginByButtonSize[props.buttonSize]}px`
      : `margin-left: ${iconMarginByButtonSize[props.buttonSize]}px`};
`;

export default IconButtonLayout;
